// Symbole fuer Stationen (erscheinen auf dem gedruckten Stationsplakat).
//
// Die Liste selbst steht in stationIcons.json, damit der Druck-Test in
// functions/tests/stationsymbole.test.js dieselbe Quelle prueft. Alle Namen
// muessen in lucide-react (Anzeige hier) UND lucide-static (Plakat-PDF)
// existieren – sonst landet auf dem Plakat stillschweigend ein Pokal.
import daten from "./stationIcons.json";

export const ICON_GRUPPEN = daten.gruppen;
export const ICON_STANDARD = daten.standard;

const ALLE = daten.gruppen.flatMap((g) => g.icons);
export const ICON_NAMEN = ALLE.map((i) => i.name);

// Ohne Umlaute und Gross-/Kleinschreibung vergleichen („Hüpfen“ = „hupfen“).
function falte(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

// Wer „Sackhuepfen“ ohne Umlaut tippt, soll dasselbe Symbol bekommen. Darum
// gilt jedes Stichwort auch in der Umschrift (ä -> ae). Den Namen selbst
// faltet man nicht so, sonst wird aus „bauen“ ein „baun“.
function varianten(wort) {
  const umschrift = wort
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue");
  return [...new Set([falte(wort), falte(umschrift)])];
}

const STICHWORTE = ALLE.flatMap((icon, reihenfolge) =>
  icon.stichworte.flatMap((wort) =>
    varianten(wort).map((v) => ({ name: icon.name, wort: v, reihenfolge }))
  )
);

// Aeltere Stationen tragen teils Namen, die es im Druck-Paket nicht gibt
// („LucideBrain“, „Cup“). Sie werden auf den heutigen Namen abgebildet.
export function normalisiereIcon(name) {
  return daten.alias[name] || name || ICON_STANDARD;
}

// Passendes Symbol zum Stationsnamen. Gewinnt das laengste Stichwort, bei
// Gleichstand das weiter vorn im Namen; gibt es keinen Treffer, bleibt es
// beim Standard (bei Schaetzstationen beim Lineal).
export function iconVorschlag(stationsname, { schaetzstation = false } = {}) {
  const text = ` ${falte(stationsname)} `;
  let best = null;
  for (const k of STICHWORTE) {
    const pos = text.indexOf(k.wort);
    if (pos < 0) continue;
    if (
      !best ||
      k.wort.length > best.laenge ||
      (k.wort.length === best.laenge &&
        (pos < best.pos || (pos === best.pos && k.reihenfolge < best.reihenfolge)))
    ) {
      best = { name: k.name, laenge: k.wort.length, pos, reihenfolge: k.reihenfolge };
    }
  }
  if (best) return best.name;
  return schaetzstation ? daten.schaetzstation : ICON_STANDARD;
}
